import React, { useEffect, useState } from 'react';
import { meetingService } from '../../services/meetingService';
import { formatFirstSessionDate } from '../../services/workshop2026Service';
import { Meeting } from '../../services/meetingService';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopCommunitySectionProps {
  meetingCode: string;
  meeting: Meeting | null;
  showPhoneList: boolean;
}

const WorkshopCommunitySection: React.FC<WorkshopCommunitySectionProps> = ({
  meetingCode,
  meeting,
  showPhoneList,
}) => {
  const [rosterNames, setRosterNames] = useState<string[]>([]);
  const [workshopStarted, setWorkshopStarted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const firstSession = formatFirstSessionDate(meeting);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const roster = await meetingService.getWorkshopRoster(meetingCode);
        if (cancelled) return;
        setRosterNames(roster.names.map((n) => n.display_name).filter(Boolean));
        setWorkshopStarted(roster.workshop_started);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Could not load participant info');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [meetingCode]);

  if (loading) return <p className={styles.helperText}>Loading…</p>;
  if (error) return <p className={styles.helperText}>{error}</p>;

  return (
    <>
      {!showPhoneList && (
        <>
          {rosterNames.length > 0 ? (
            <p className={styles.rosterNames}>
              Confirmed participants include {rosterNames.join(', ')}.
            </p>
          ) : (
            <p className={styles.helperText}>
              No one has chosen to show their name yet
              {!workshopStarted ? ' before the workshop starts' : ''}.
            </p>
          )}

          <p className={styles.helperText}>
            Phone and email lists will be available to confirmed members when the workshop starts
            {firstSession !== 'date TBD' ? ` (${firstSession})` : ''}. You can opt in under
            preferences.
          </p>
        </>
      )}
    </>
  );
};

export default WorkshopCommunitySection;
